import { useCallback, useEffect, useRef } from 'react';
import {
  createObjectUrlHandle,
  type ObjectUrlHandle,
} from './object-url-handle';

export function useObjectUrlLifecycle() {
  const handlesRef = useRef(new Map<string, ObjectUrlHandle>());

  const releaseObjectUrl = useCallback((consumerId?: string) => {
    if (consumerId) {
      handlesRef.current.get(consumerId)?.revoke();
      handlesRef.current.delete(consumerId);
      return;
    }

    for (const handle of handlesRef.current.values()) {
      handle.revoke();
    }
    handlesRef.current.clear();
  }, []);

  const replaceObjectUrl = useCallback(
    (object: Blob, consumerId = 'default') => {
      releaseObjectUrl(consumerId);
      const handle = createObjectUrlHandle(object);
      handlesRef.current.set(consumerId, handle);
      return handle.url;
    },
    [releaseObjectUrl],
  );

  useEffect(() => releaseObjectUrl, [releaseObjectUrl]);

  return { replaceObjectUrl, releaseObjectUrl };
}
